export var Capability;
(function (Capability) {
    Capability["can_place_landmarks"] = "can_place_landmarks";
    Capability["has_accelerometer"] = "has_accelerometer";
    Capability["has_accelerometer_toggle"] = "has_accelerometer_toggle";
    Capability["has_alarm_button"] = "has_alarm_button";
    Capability["has_alice"] = "has_alice";
    Capability["has_autoguard"] = "has_autoguard";
    Capability["has_autoscan_packets"] = "has_autoscan_packets";
    Capability["has_autoscan_settings"] = "has_autoscan_settings";
    Capability["has_autoscan_tracking"] = "has_autoscan_tracking";
    Capability["has_autostart"] = "has_autostart";
    Capability["has_battery"] = "has_battery";
    Capability["has_battery_percent"] = "has_battery_percent";
    Capability["has_boiler_delay"] = "has_boiler_delay";
    Capability["has_car_controls"] = "has_car_controls";
    Capability["has_car_diagnostics"] = "has_car_diagnostics";
    Capability["has_car_sensors"] = "has_car_sensors";
    Capability["has_classic_autoscan_commands"] = "has_classic_autoscan_commands";
    Capability["has_climatic_interface"] = "has_climatic_interface";
    Capability["has_config_file"] = "has_config_file";
    Capability["has_custom_controls_schedule"] = "has_custom_controls_schedule";
    Capability["has_ecu_errors_reset"] = "has_ecu_errors_reset";
    Capability["has_engine_block"] = "has_engine_block";
    Capability["has_ethernet"] = "has_ethernet";
    Capability["has_external_panel"] = "has_external_panel";
    Capability["has_external_rf"] = "has_external_rf";
    Capability["has_extmodes"] = "has_extmodes";
    Capability["has_extmodes_dayschedules"] = "has_extmodes_dayschedules";
    Capability["has_extmodes_sensors"] = "has_extmodes_sensors";
    Capability["has_firmware_upgrade"] = "has_firmware_upgrade";
    Capability["has_fob_battery_notification"] = "has_fob_battery_notification";
    Capability["has_fuel_consumption"] = "has_fuel_consumption";
    Capability["has_global_freeze_packets"] = "has_global_freeze_packets";
    Capability["has_glt_reports"] = "has_glt_reports";
    Capability["has_gps"] = "has_gps";
    Capability["has_gsm"] = "has_gsm";
    Capability["has_gsm_balance"] = "has_gsm_balance";
    Capability["has_gsm_blackout_notification"] = "has_gsm_blackout_notification";
    Capability["has_gtw_internet_weather"] = "has_gtw_internet_weather";
    Capability["has_gtw_reports"] = "has_gtw_reports";
    Capability["has_guard_notification"] = "has_guard_notification";
    Capability["has_guard_state"] = "has_guard_state";
    Capability["has_optional_guard"] = "has_optional_guard";
    Capability["has_handsfree"] = "has_handsfree";
    Capability["has_l1000_logfile"] = "has_l1000_logfile";
    Capability["has_l1000_multi"] = "has_l1000_multi";
    Capability["has_lithium_battery"] = "has_lithium_battery";
    Capability["has_lithium_ztc"] = "has_lithium_ztc";
    Capability["has_lua_profile"] = "has_lua_profile";
    Capability["has_multiple_thermometer_functions"] = "has_multiple_thermometer_functions";
    Capability["has_multiple_thermometers"] = "has_multiple_thermometers";
    Capability["has_notifications"] = "has_notifications";
    Capability["has_offline_notifications"] = "has_offline_notifications";
    Capability["has_optional_thermostat"] = "has_optional_thermostat";
    Capability["has_ot_gate"] = "has_ot_gate";
    Capability["has_pcn_arsenal"] = "has_pcn_arsenal";
    Capability["has_pza"] = "has_pza";
    Capability["has_pza_internet_weather"] = "has_pza_internet_weather";
    Capability["has_radiosilence"] = "has_radiosilence";
    Capability["has_rf"] = "has_rf";
    Capability["has_rf_fobs"] = "has_rf_fobs";
    Capability["has_serverside_events_notifications"] = "has_serverside_events_notifications";
    Capability["has_service_password"] = "has_service_password";
    Capability["has_sim_in_device"] = "has_sim_in_device";
    Capability["has_siren_control"] = "has_siren_control";
    Capability["has_sx_config"] = "has_sx_config";
    Capability["has_telpassword"] = "has_telpassword";
    Capability["has_temperature_sensors"] = "has_temperature_sensors";
    Capability["has_thermometer_functions"] = "has_thermometer_functions";
    Capability["has_thermostat"] = "has_thermostat";
    Capability["has_thermostat_hysteresis"] = "has_thermostat_hysteresis";
    Capability["has_tracker_mode"] = "has_tracker_mode";
    Capability["has_trusted_phones"] = "has_trusted_phones";
    Capability["has_upload_voicepack_button"] = "has_upload_voicepack_button";
    Capability["has_voice_siren"] = "has_voice_siren";
    Capability["has_voltage_12v_low_level"] = "has_voltage_12v_low_level";
    Capability["has_voltage_sensor"] = "has_voltage_sensor";
    Capability["has_webasto"] = "has_webasto";
    Capability["has_wifi"] = "has_wifi";
    Capability["has_wifi_v2"] = "has_wifi_v2";
    Capability["has_work_state"] = "has_work_state";
    Capability["has_z3k_settings"] = "has_z3k_settings";
    Capability["has_zta110_inputconfig"] = "has_zta110_inputconfig";
    Capability["has_zta110_outputconfig"] = "has_zta110_outputconfig";
    Capability["has_ztc110_guard_polarity"] = "has_ztc110_guard_polarity";
    Capability["has_ztc110_inputconfig"] = "has_ztc110_inputconfig";
    Capability["has_ztc_state_packets"] = "has_ztc_state_packets";
    Capability["has_ztcconfig_autostart"] = "has_ztcconfig_autostart";
    Capability["has_ztcconfig_battery"] = "has_ztcconfig_battery";
    Capability["has_ztcconfig_locking"] = "has_ztcconfig_locking";
    Capability["has_ztcconfig_siren"] = "has_ztcconfig_siren";
    Capability["has_zth_inputs"] = "has_zth_inputs";
    Capability["is_alien_device"] = "is_alien_device";
    Capability["is_fixed_alarm"] = "is_fixed_alarm";
    Capability["is_old_autoscan_device"] = "is_old_autoscan_device";
    Capability["no_rf_add_button"] = "no_rf_add_button";
    Capability["no_rf_del_button"] = "no_rf_del_button";
})(Capability || (Capability = {}));
